import React, { useEffect, useState } from "react";
import { Radio, Col, Row, DatePicker, Form, FormInstance, Select, Checkbox, Tag } from 'antd';
import dayjs from 'dayjs';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import type { RadioChangeEvent } from 'antd';

import { IMandatoDirigente } from "../../Componentes/InterfaceMandato";
import { IEntidade } from "../../../../Interfaces/DadosPrevicInterfaces";
import { hasPermissao, Papel } from "../../../../auth/entidadeUsuario";
import { CategoriasDirigente } from "../../../../config/Contantes";

interface IProps {
  form: FormInstance<any>;
  entidades: IEntidade[];
  setValueCategoria: React.Dispatch<React.SetStateAction<number>>;
  setValueCondicao: React.Dispatch<React.SetStateAction<number>>;
  setValueRepresentacao: React.Dispatch<React.SetStateAction<number>>;
  valueCategoria: number;
  valueCondicao: number;
  valueRepresentacao: number;
  dadosConselheiro?: IMandatoDirigente;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

const { Option } = Select;
const ConselheiroPerfil = ({ form, entidades, setValueCategoria, valueCategoria, setValueCondicao, valueCondicao, setValueRepresentacao, valueRepresentacao, manter, dadosConselheiro }: IProps) => {

  const [checkProrrogacao, setCheckProrrogacao] = useState(false)
  const [checkProrrogacaoNaBase, setCheckProrrogacaoNaBase] = useState(false)

  const [checkReconducao, setCheckReconducao] = useState(false)
  const [checkReconducaoNaBase, setCheckReconducaoNaBase] = useState(false)

  const handlerEntidade = async (value: any) => {
    form.setFieldsValue({
      sigla: value.children,
      matriculaEfpc: value.key,
    });
  };

  const handlerCheckProrrogacao = (e: CheckboxChangeEvent) => {
    form.setFieldsValue({
      "checkProrrogacao": e.target.checked,
    });
    setCheckProrrogacao(e.target.checked);
  };

  const handlerCheckReconducao = (e: CheckboxChangeEvent) => {
    form.setFieldsValue({
      "checkReconducao": e.target.checked,
    });
    setCheckReconducao(e.target.checked);
  };

  const onChangeRadioCategoria = (e: RadioChangeEvent) => {
    setValueCategoria(e.target.value);
  };

  const onChangeRadioCondicao = (e: RadioChangeEvent) => {
    setValueCondicao(e.target.value);
  };

  const onChangeRadioRepresentacao = (e: RadioChangeEvent) => {
    setValueRepresentacao(e.target.value);
  };

  const hasPermissaoCampoSensivel = ()=>{
    if (hasPermissao([Papel.DILIC_MASTER, Papel.DILIC_USUARIO])){
      return true;
    } else if (!hasPermissao([Papel.ENTIDADE_ALTERAR])){
      return false;
    }
    let entidade = dadosConselheiro?.entidade;
    if (!entidade){
      if (entidades.length === 1){
        entidade = entidades[0];
      } else {
        const matrEfpc = form?.getFieldValue("matriculaEfpc");
        if (manter === 1 && !matrEfpc){
          return true;
        }
        for (let ent of entidades){
          if (ent.matricula === matrEfpc){
            entidade = ent;
            break;
          }
        }
        console.log('Erro desconhecido: Nenhuma entidade ativa?');
      }
    }
    return [3, 4].includes(entidade?.codigoEnquadramento ?? 0);
  }

  useEffect(() => {
    if (manter === 2 || manter === 3 || manter === 9) { // DETALHAR OU ALTERAR OU HISTÓRICO
      if (dadosConselheiro?.prorrogacao) {
        setCheckProrrogacao(dadosConselheiro.prorrogacao);
        setCheckProrrogacaoNaBase(dadosConselheiro?.prorrogacao);
      }

      if (dadosConselheiro?.reconducao) {
        setCheckReconducao(dadosConselheiro?.reconducao);
        setCheckReconducaoNaBase(dadosConselheiro.reconducao);
      }

      if (dadosConselheiro?.csCategoria) setValueCategoria(dadosConselheiro.csCategoria);
      if (dadosConselheiro?.csCondicaoMandato) setValueCondicao(dadosConselheiro.csCondicaoMandato);
      if (dadosConselheiro?.csRepresentacao) setValueRepresentacao(dadosConselheiro.csRepresentacao);

      form.setFieldsValue({
        "checkProrrogacao": dadosConselheiro?.prorrogacao,
        "checkReconducao": dadosConselheiro?.reconducao,
        "radioCategoria": dadosConselheiro?.csCategoria,
        "radioCondicao": dadosConselheiro?.csCondicaoMandato,
        "radioRepresentacao": dadosConselheiro?.csRepresentacao,
      });
    }

  }, [dadosConselheiro])

  return (
    <>
      <Row>
        <Col xs={4} xl={6} style={{ display: manter === 1 ? 'none' : 'inline' }} >
          <Form.Item label="Situação"
            labelCol={{ span: 24 }}
            colon={false}
          >
            <Tag color={dadosConselheiro?.situacaoVigencia ? "geekblue" : "volcano"} key={dadosConselheiro?.idMandato}>
              {dadosConselheiro?.situacaoVigencia && dadosConselheiro.situacaoVigencia ? "ATIVO" : "INATIVO"}
            </Tag>
          </Form.Item>
        </Col>

        <Col xs={24} xl={6} >
          <Form.Item label="Categoria"
            name="radioCategoria"
            colon={false}
          >
            <Radio.Group
              disabled={manter === 2 || manter === 9 || !hasPermissaoCampoSensivel()}
              onChange={onChangeRadioCategoria} defaultValue={manter === 1 ? valueCategoria : 0}>
              <Radio value={CategoriasDirigente["DELIBERATIVO"].value}>{CategoriasDirigente["DELIBERATIVO"].label}</Radio>
              <Radio value={CategoriasDirigente["FISCAL"].value}>{CategoriasDirigente["FISCAL"].label}</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>


        <Col xs={24} xl={12}>
          <Form.Item label="Entidade"
            // labelCol={{ span: 24 }}
            name="sigla"
            colon={false}
            rules={[
              {
                required: true,
                message: "A entidade é obrigatória",
              },
            ]}
          >
            <Select
              disabled={manter !== 1 ? true : entidades.length === 1}
              showSearch
              filterOption
              optionFilterProp='children'
              placeholder='Selecione a entidade'
              onChange={(_, index) => {
                handlerEntidade(index);
              }}
            >
              {entidades?.map((e: IEntidade) => (
                <Option key={e.matricula} value={e.matricula}>
                  {e.sigla}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col xs={8} xl={6}>
          <Form.Item label="Data Inicial do Mandato"
            name="dtInicioMandato"
            colon={false}
            style={{ flexDirection: "column", alignItems: "flex-start" }}
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
            ]}
          >
            <DatePicker
              disabled={manter === 2 || manter === 9 || !hasPermissaoCampoSensivel()}
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
              placeholder="Selecionar Data"
            />
          </Form.Item>
        </Col>

        <Col xs={8} xl={6}>
          <Form.Item label="Data Final do Mandato"
            name="dtFimMandato"
            colon={false}
            style={{ flexDirection: "column", alignItems: "flex-start" }}
            rules={[
              {
                required: true,
                message: "Campo obrigatório",
              },
              {
                validator: async (_, endDatetime) => {
                  let startDatetime = form.getFieldValue("dtInicioMandato");
                  if (endDatetime && startDatetime) {
                    endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                    startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                    if (endDatetime <= startDatetime) {
                      return Promise.reject(
                        "Data de final do mandato deve ser maior do que à data inicial"
                      );
                    }
                  }
                },
              },
            ]}
          >
            <DatePicker
              disabled={manter === 2 || manter === 9 ? true : false}
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
              placeholder="Selecionar Data"
            />
          </Form.Item>
        </Col>

        <Col xs={8} xl={6}>
          <Form.Item label="Início do Exercício"
            name="dtInicioExercicio"
            colon={false}
            style={{ flexDirection: "column", alignItems: "flex-start" }}
            rules={[
              {
                validator: async (_, dtInicioExercicio) => {
                  let dtInicioMandato = form.getFieldValue("dtInicioMandato");
                  if (dtInicioExercicio && dtInicioMandato) {
                    dtInicioExercicio = dayjs(dtInicioExercicio).format("YYYY-MM-DD")
                    dtInicioMandato = dayjs(dtInicioMandato).format("YYYY-MM-DD")
                    if (dtInicioExercicio < dtInicioMandato) {
                      return Promise.reject(
                        "Data de início do exercício deve ser maior ou igual à data de início do mandato"
                      );
                    }
                  }
                },
              },
            ]}
          >
            <DatePicker
              disabled={manter === 2 || manter === 9 ? true : false}
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
              placeholder="Selecionar Data"
            />
          </Form.Item>
        </Col>

        <Col xs={8} xl={6}>
          <Form.Item label="Fim do Exercício"
            name="dtFimExercicio"
            colon={false}
            style={{ flexDirection: "column", alignItems: "flex-start" }}
            rules={[
              {
                validator: async (_, endDatetime) => {
                  let startDatetime = form.getFieldValue("dtInicioExercicio");
                  if (endDatetime && startDatetime) {
                    endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                    startDatetime = dayjs(startDatetime).format("YYYY-MM-DD")
                    if (endDatetime <= startDatetime) {
                      return Promise.reject(
                        "Data de final do exercício deve ser maior do que a data de inicial"
                      );
                    }
                  }
                },
              },
              {
                validator: async (_, endDatetime) => {
                  let dtFimMandato = form.getFieldValue("dtFimMandato");
                  if (endDatetime && dtFimMandato) {
                    endDatetime = dayjs(endDatetime).format("YYYY-MM-DD")
                    dtFimMandato = dayjs(dtFimMandato).format("YYYY-MM-DD")
                    if (endDatetime > dtFimMandato) {
                      return Promise.reject(
                        "Data de final do exercício deve ser maior ou igual à data final do mandato"
                      );
                    }
                  }
                },
              },
            ]}
          >
            <DatePicker
              disabled={manter === 2 || manter === 9 ? true : false}
              format={"DD/MM/YYYY"}
              style={{ width: "100%" }}
              placeholder="Selecionar Data"
            />
          </Form.Item>
        </Col>

      </Row>

      <Row>

        <Col xs={24} xl={6} >
          <Form.Item label="Condição"
            name="radioCondicao"
            colon={false}
          >
            <Radio.Group
              disabled={manter === 2 || manter === 9 || !hasPermissaoCampoSensivel()}
              onChange={onChangeRadioCondicao} defaultValue={manter === 1 ? valueCondicao : 0}>
              <Radio value={1}>Titular</Radio>
              <Radio value={2}>Suplente</Radio>
            </Radio.Group>

          </Form.Item>
        </Col>

        <Col xs={24} xl={12} >
          <Form.Item label="Representação"
            name="radioRepresentacao"
            colon={false}
          >
            <Radio.Group
              disabled={manter === 2 || manter === 9 || !hasPermissaoCampoSensivel()}
              onChange={onChangeRadioRepresentacao} defaultValue={manter === 1 ? valueRepresentacao : 0}>
              <Radio value={1}>Participantes/Assistidos</Radio>
              <Radio value={2}>Patrocinadores/Instituidores</Radio>
            </Radio.Group>

          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col xs={24} xl={6} style={{ display: manter === 1 ? 'none' : 'inline' }} >
          <Form.Item label=" " name="checkProrrogacao"
            colon={false}
          >
            <Checkbox
              disabled={(manter === 1 || manter === 2 || manter === 9) ? true : checkProrrogacaoNaBase || false}
              checked={checkProrrogacao}
              onChange={handlerCheckProrrogacao}
            >
              Prorrogação
            </Checkbox>
          </Form.Item>
        </Col>

        <Col xs={24} xl={6} style={{ display: manter === 1 ? 'none' : 'inline' }} >
          <Form.Item label=" " name="checkReconducao"
            colon={false}
          >
            <Checkbox
              disabled={(manter === 1 || manter === 2 || manter === 9) ? true : checkReconducaoNaBase || false}
              checked={checkReconducao}
              onChange={handlerCheckReconducao}
            >
              Recondução
            </Checkbox>
          </Form.Item>
        </Col>

      </Row>

    </>
  )
};

export default ConselheiroPerfil;